import script from "./CustomerRemoteSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerRemoteSelect.vue?vue&type=script&setup=true&lang=js"

import "./CustomerRemoteSelect.vue?vue&type=style&index=0&id=2d44a64b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d44a64b"]])

export default __exports__